module.exports = __webpack_public_path__ + "static/img/20.51d76a16.png";